<template>
  <div class="container">
    <div class="columns">
      <div class="column is-6">
        <LsSupportHeader label="What's included in my mowing service?" />
      </div>
    </div>
    <div class="columns">
      <div class="column is-6">
        <p>
          Your regular lawn mowing service includes mowing of 3-{{ longGrassHeights.fee }} inches of
          grass, edging around curbs, sidewalks and flower beds, and blowing chippings off of hard
          surfaces.
        </p>
        <p>
          Looking for additional services?
          <RouterLink test-id="other_services" :to="{ name: 'whatOtherServices' }"
            >See other services we offer</RouterLink
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { LsSupportHeader } from '../components';
import { lsLongGrassHelpers } from '@/helpers';

export default {
  name: 'WhatsIncludedView',
  components: {
    LsSupportHeader,
  },
  computed: {
    longGrassHeights() {
      return lsLongGrassHelpers.getLongGrassCutoffLengths();
    },
  },
};
</script>

<style lang="scss" scoped>
p:not(:last-child) {
  margin-bottom: 16px;
}
</style>
